<div class="pagination-controls">
    <span>Total {{totalItems}}</span>
    <select class="form-select" [(ngModel)]="itemsPerPage" (change)="changeItemsPerPage()">
      <option value="10" selected>10/page</option>
      <option value="25">25/page</option>
      <option value="50">50/page</option>
      <option value="100">100/page</option>
    </select>
    <button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">
        <img class="image-arrow-pre" src="./assets/images/icon-pagination-next.png" alt="">
    </button>
    <ng-container>
        <!-- Show first page and ellipsis if currentPage > 3 -->
        <button *ngIf="currentPage > 3" (click)="changePage(1)">1</button>
        <span *ngIf="currentPage > 3">...</span>

        <!-- Display dynamic page buttons -->
        <div *ngFor="let page of pages">
            <button *ngIf="checkPagination(page)" (click)="changePage(page)" [class.active]="page === currentPage">{{
                page }}</button>
        </div>

        <!-- Show ellipsis and last page if not near the end -->
        <span *ngIf="totalPages - currentPage > 2 && currentPage != totalPages">...</span>
        <button *ngIf="totalPages - currentPage > 1 && currentPage != totalPages && totalPages > 3"
            (click)="changePage(totalPages)" [class.active]="totalPages === currentPage">
            {{ totalPages }}
        </button>
    </ng-container>
    <button (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages">
        <img src="./assets/images/icon-pagination-next.png" alt="" height="14" width="14">
    </button>
    <span>Go to</span>
    <input class="goto form-control" type="number" [ngModel]="currentPage" (keyup.enter)="gotoPage($event)">
</div>